import enLang from './entries/en_US';
import zhLang from './entries/zh_CN';
import frLang from './entries/fr_FR';
import jaLang from './entries/ja_JP'
import esLang from './entries/es'

const AppLocale = {
    en: enLang,
    zh: zhLang,
    fr: frLang,
    ja: jaLang,
    es: esLang
};

export default AppLocale;
